var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60002 15.8C7.60002 16.7942 6.79414 17.6 5.80002 17.6C4.80591 17.6 4.00002 16.7942 4.00002 15.8C4.00002 14.8059 4.80591 14 5.80002 14C6.79414 14 7.60002 14.8059 7.60002 15.8Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.8C16 16.7942 15.1941 17.6 14.2 17.6C13.2059 17.6 12.4 16.7942 12.4 15.8C12.4 14.8059 13.2059 14 14.2 14C15.1941 14 16 14.8059 16 15.8Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60002 0.800049C0.937283 0.800049 0.400024 1.33731 0.400024 2.00005V14C0.400024 14.6628 0.937283 15.2 1.60002 15.2H2.86004C3.138 13.8307 4.34865 12.8 5.80002 12.8C7.2514 12.8 8.46205 13.8307 8.74001 15.2H10C10.6628 15.2 11.2 14.6628 11.2 14V2.00005C11.2 1.33731 10.6628 0.800049 10 0.800049H1.60002Z",
    fill: "#6B7280"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 4.40005C14.1373 4.40005 13.6 4.93731 13.6 5.60005V12.8601C13.7939 12.8207 13.9945 12.8 14.2 12.8C15.6514 12.8 16.8621 13.8307 17.14 15.2H18.4C19.0628 15.2 19.6 14.6628 19.6 14V8.00005C19.6 7.68179 19.4736 7.37656 19.2486 7.15152L16.8486 4.75152C16.6235 4.52648 16.3183 4.40005 16 4.40005H14.8Z",
    fill: "#6B7280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentIcon);
export default __webpack_public_path__ + "static/media/shipmentIcon.ad8e3e302ce99d8ec1bcb155bc82a2fd.svg";
export { ForwardRef as ReactComponent };